import { createContext, useContext } from 'react'

export const defaultTheme = {
  mainColor: '#FABE0A',
  mainTextColor: '#000000',
}

export const ThemeContext = createContext<{
  mainColor: string
  mainTextColor: string
}>(defaultTheme)

export function useTheme() {
  const theme = useContext(ThemeContext)
  if (!theme) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return theme
}
